import { Component, OnInit } from '@angular/core';
import { HeadersFacade } from '../../../domain/facades/facades';
import { HeaderThemesService } from '../../../domain/services/HeaderThemesService.service';
import { mobile_search_view_inteface, search_result_interface } from '../../../domain/entites/HeaderThemes.model';
import { Router } from '@angular/router';





@Component({
  selector: 'ima-header-mobile-search-view',
  templateUrl: './mobile-search-view.component.html',
  styleUrls: ['./mobile-search-view.component.css']
})
export class MobileSearchViewComponent implements OnInit 
{

  mobile_search_view_state: mobile_search_view_inteface = {
    display: false,
    search_text: '',
    search_result: []
  };

  
  constructor(
    public facades: HeadersFacade,
    private router: Router
  ) {}

  ngOnInit(): void 
  {
    this.listen_to_states();
  }


  listen_to_states()
  {
    this.facades.mobile_search_view_selector$.subscribe(
      (mobile_search_view_state)=>{
        this.mobile_search_view_state = mobile_search_view_state;
      }
    );
  }

  hideSearchBar() 
  {
    this.emptySearchInput();
    this.facades.toggle_mobile_search_view_state(false);
  }

  emptySearchInput() 
  {
    this.facades.mobile_search_view_empty_search();
  }

  searching(searching_string: any)
  {
    this.facades.mobile_search(searching_string.target.value);
  }

  redirect(product: search_result_interface)
  {

    if ( product?.name && product?.id )
    {
      this.router.navigate([ 'mobile', 'products', 'product-details', product?.id, product?.name ]);
      this.hideSearchBar();
    }

  }


}
